import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=68c6149c&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=68c6149c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6149c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c6149c')) {
      api.createRecord('68c6149c', component.options)
    } else {
      api.reload('68c6149c', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=68c6149c&scoped=true&", function () {
      api.rerender('68c6149c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wsgtdrive/Edit.vue"
export default component.exports